import { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import Footer from '../../components/Footer';
import ArticleDetail from './ArticleDetail';
import articlesData from '../../data/articles.json';
import '../Pages.css';

function Articles() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const articleId = queryParams.get('id');

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [sortOrder, setSortOrder] = useState('desc'); // 'desc' for newest first, 'asc' for oldest first
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  // If there's an article ID in the query string, show the article detail
  if (articleId) {
    return <ArticleDetail />;
  }

  const filterArticles = () => {
    return articlesData.filter(article => {
      const articleDate = new Date(article.date + 'T00:00:00');

      if (startDate && endDate) {
        const start = new Date(startDate + 'T00:00:00');
        const end = new Date(endDate + 'T00:00:00');
        return articleDate >= start && articleDate <= end;
      } else if (startDate) {
        const start = new Date(startDate + 'T00:00:00');
        return articleDate >= start;
      } else if (endDate) {
        const end = new Date(endDate + 'T00:00:00');
        return articleDate <= end;
      }

      return true;
    });
  };

  const clearFilter = () => {
    setStartDate('');
    setEndDate('');
  };

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === 'desc' ? 'asc' : 'desc');
  };

  const filteredArticles = filterArticles().sort((a, b) => {
    const dateA = new Date(a.date + 'T00:00:00');
    const dateB = new Date(b.date + 'T00:00:00');
    return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
  });

  return (
    <div className="Page">
      <PageHeader />
      <div className="Page-container">
        <h1>Articles</h1>

        <div className="date-filter">
          <button
            className="filter-toggle-btn"
            onClick={() => setIsFilterOpen(!isFilterOpen)}
          >
            <span>Filter & Sort</span>
            {(startDate || endDate) && <span className="filter-active-indicator">●</span>}
            <span className={`filter-arrow ${isFilterOpen ? 'open' : ''}`}>▼</span>
          </button>

          {isFilterOpen && (
            <div className="date-filter-content">
              <div className="date-filter-inputs">
                <div className="filter-group">
                  <label htmlFor="start-date">From:</label>
                  <input
                    type="date"
                    id="start-date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="date-input"
                  />
                </div>
                <div className="filter-group">
                  <label htmlFor="end-date">To:</label>
                  <input
                    type="date"
                    id="end-date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="date-input"
                  />
                </div>
                <button onClick={toggleSortOrder} className="sort-btn">
                  Sort: {sortOrder === 'desc' ? 'Newest First' : 'Oldest First'}
                </button>
                {(startDate || endDate) && (
                  <button onClick={clearFilter} className="clear-filter-btn">
                    Clear Filter
                  </button>
                )}
              </div>
              <p className="filter-results">
                Showing {filteredArticles.length} of {articlesData.length} articles
              </p>
            </div>
          )}
        </div>

        {filteredArticles.length > 0 ? (
          filteredArticles.map((article) => (
            <section key={article.id} className="Page-section">
              <Link to={`/articles?id=${article.id}`} className="article-title-link">
                <h2>{article.title}</h2>
              </Link>
              <p className="article-meta">
                By {article.author} | {new Date(article.date + 'T00:00:00').toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  timeZone: 'UTC'
                })}
              </p>
              <p className="article-summary"><strong>{article.summary}</strong></p>
              <Link to={`/articles?id=${article.id}`} className="read-more-link">
                Read More →
              </Link>
            </section>
          ))
        ) : (
          <p className="no-results">No articles found for the selected date range.</p>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default Articles;
